<div class="faux-container">
  <div class="message-container mb-3">
    @if (!displayNextRequiredCategoryButton) {
      <div class="d-inline-flex w-100 align-items-center justify-content-between">
        <span class="me-3">
          <mwp-text-translate text="Read the content below and click the button to the next category when ready." jsonKey="fuaxCategoryNote" />
        </span>
        <button class="mwp-button" (click)="gotoNextCategory()">
          <mwp-text-translate text="Next Category" jsonKey="nextCategory" />
        </button>
      </div>
    }
    @if (displayNextRequiredCategoryButton) {
      <div class="d-inline-flex w-100 align-items-center justify-content-between">
        <span class="me-3">
          <mwp-text-translate text="Read the content below and click the button to the next required category when ready." jsonKey="fuaxCategoryNote2" />
        </span>
        <button class="mwp-button" (click)="gotoNextCategory()">
          <mwp-text-translate text="Next Required Category" jsonKey="nextRequiredCategory" />
        </button>
      </div>
    }
  </div>
  @if (!displayDefaultCard) {
    <div [innerHTML]="enrollmentCategoryOptions.fauxHTML | pipeSafeHTML">
    </div>
  }
  @if (displayDefaultCard) {
    <div>
      @if (isAgent) {
        <div class="static-card agent">
          <div class="w-100 d-flex justify-content-center mb-2">
            <div class="d-inline-flex">
              <div class="me-5">
                <img src="assets/images/icons/computer.svg" alt="Computer icon" />
              </div>
              <div class="ms-5">
                <img src="assets/images/icons/person.svg" alt="Person icon" />
              </div>
            </div>
          </div>
          <div class="text-center">
            <mwp-text-translate text="The benefits available in this category require the member to independently add, modify, and/or terminate coverage. Please direct the employee to login and complete the benefit enrollment process on their own." jsonKey="fauxCategory1" />
          </div>
        </div>
      }
      @if (!isAgent) {
        <div class="static-card">
          <div class="w-100 d-flex justify-content-center mb-2">
            <div class="d-inline-flex">
              <div class="me-5">
                <img src="assets/images/icons/meeting.svg" alt="Meeting icon" />
              </div>
              <div class="ms-5">
                <img src="assets/images/icons/call_center.svg" alt="Call Center icon" />
              </div>
            </div>
          </div>
          <div class="text-center">
            <mwp-text-translate text="The benefits available in this category require the assistance of a licensed agent to add, modify, and/or terminate coverage. Please arrange to meet with an enrollment counselor or contact an available call center representative for assistance." jsonKey="fauxCategory2" />
          </div>
        </div>
      }
    </div>
  }
</div>